import { useRef, useState, useCallback, useEffect } from "react";
import { toast } from "sonner";

export function useMicPassthrough() {
    const micTrackRef = useRef(null);
    const [micOn, setMicOn] = useState(false);

    const toggleMic = useCallback(async () => {
        if (micTrackRef.current) {
            micTrackRef.current.stop();
            micTrackRef.current = null;
            setMicOn(false);
            toast.info("Mic muted — OBS audio off");
            return;
        }
        try {
            const s = await navigator.mediaDevices.getUserMedia({ audio: true });
            micTrackRef.current = s.getAudioTracks()[0];
            setMicOn(true);
            toast.success("Mic live — voice flowing to OBS");
        } catch (e) {
            toast.error("Microphone access denied — allow mic permission to send voice to OBS");
        }
    }, []);

    useEffect(
        () => () => {
            micTrackRef.current?.stop();
            micTrackRef.current = null;
        },
        []
    );

    return { micOn, toggleMic, micTrackRef };
}
